// resources/js/widgets/contact/useContactLinks.ts
import { computed } from 'vue';

export function useContactLinks(props: {
    phone?: string;
    email?: string;
    address?: string;
    map_provider?: 'google' | 'osm';
}) {
    const phoneHref = computed(() =>
        props.phone ? `tel:${props.phone.replace(/[^\d+]/g, '')}` : '#'
    );

    const emailHref = computed(() => (props.email ? `mailto:${props.email}` : '#'));

    const mapHref = computed(() => {
        if (!props.address) return '#';
        const q = encodeURIComponent(props.address);
        return props.map_provider === 'osm'
            ? `https://www.openstreetmap.org/search?query=${q}`
            : `https://www.google.com/maps/search/?api=1&query=${q}`;
    });

    return { phoneHref, emailHref, mapHref };
}
